import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    return <Navigate to={user.role === "superadmin" ? "/tenants" : "/dashboard"} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.success) {
      setError(res.error);
      return;
    }
    navigate("/dashboard");
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}>
      <section className="view" style={{ width: "100%", maxWidth: 460 }}>
        <div className="page-head" style={{ marginBottom: 20, textAlign: "center", display: "block" }}>
          <div className="eyebrow" style={{ textAlign: "center" }}>Auth</div>
          <h1 style={{ textAlign: "center" }}>Login</h1>
          <p style={{ margin: "10px auto 0", textAlign: "center" }}>One account per person; access is scoped by role.</p>
          <div className="role-chips" style={{ justifyContent: "center" }}>
            <span className="chip">Super Admin</span>
            <span className="chip">Admin</span>
            <span className="chip">Shop Admin</span>
          </div>
        </div>
        <div className="card">
          <div className="section-head">
            <div>
              <h2>Sign in</h2>
              <p>Ask your Admin if you don't have credentials</p>
            </div>
          </div>
          <div className="login-wrap">
            <form className="login-card" onSubmit={handleSubmit}>
              <div className="field" style={{ padding: 0 }}>
                <label className="field-label">Email</label>
                <input
                  className="input" style={{ width: "100%" }} type="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com" data-testid="login-email-input"
                />
              </div>
              <div className="field" style={{ padding: 0, marginTop: 12 }}>
                <label className="field-label">Password</label>
                <input
                  className="input" style={{ width: "100%" }} type="password" required
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••" data-testid="login-password-input"
                />
              </div>
              {error && (
                <p style={{ color: "var(--red)", fontSize: 12, marginTop: 12 }} data-testid="login-error">{error}</p>
              )}
              <button
                className="btn btn-primary" type="submit" disabled={loading}
                style={{ width: "100%", marginTop: 16, justifyContent: "center" }}
                data-testid="login-submit-btn"
              >
                {loading ? "Signing in…" : "Log in"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
